module.exports = __webpack_public_path__ + "static/media/Presentation.59dab472.svg";